import { Navigate, useSearch } from '@tanstack/react-router';
import {
  useCurrentRole,
  useCurrentUser,
  useIsCurrentUserAdmin,
  useIsUserOnboarder,
} from 'hooks/slices';
import { lazy } from 'react';
import { useAuthStore } from 'stores/authStore';
import { canAccessLabPages, canAccessPharmacyPages } from './routeUtils';

const Page403 = lazy(() => import('pages/shared/errors/Page403/Page403'));
const AccountSuspendedPage = lazy(
  () => import('pages/shared/errors/AccountSuspendedPage/AccountSuspendedPage')
);

const RootNavigate = () => {
  const authToken = useAuthStore((state) => state.userToken);
  const isUserAdmin = useIsCurrentUserAdmin();
  const isUserOnboarder = useIsUserOnboarder();
  const currentUser = useCurrentUser();
  const role = useCurrentRole();
  const { redirection_url } = useSearch({ strict: false });

  if (authToken === null) {
    return <Navigate to="/login" search={{ redirection_url: redirection_url }} replace />;
  }

  if (isUserAdmin) return <Navigate to="/admin" replace />;

  if (isUserOnboarder) return <Navigate to="/onboarder" replace />;
  if (role?.resource_type === 'Group') {
    if (!role.resource.is_active) {
      return <AccountSuspendedPage />;
    }
    return <Navigate to="/group" replace />;
  }
  if (role?.resource_type === 'Lab') {
    if (canAccessLabPages(currentUser, role)) {
      return <Navigate to="/lab" replace />;
    } else {
      return <Page403 showLogoutButton />;
    }
  }
  if (role?.resource_type === 'Pharmacy' && canAccessPharmacyPages(currentUser, role)) {
    return <Navigate to="/pharmacy" replace />;
  }
  return <Navigate to="/onboarding" replace />;
};

export default RootNavigate;
